const carousel = () => ({
    index: 1,
    init() {
        setInterval(() => {
            if (this.index >= this.$refs.carousel.children.length) {
                this.index = 0
            }

            const childPosition = this.$refs.carousel.children[this.index].getBoundingClientRect()
            const firstChildPosition = this.$refs.carousel.children[0].getBoundingClientRect()
            const top = childPosition.top - firstChildPosition.top

            this.$refs.carousel.scrollTo({
                top,
                behavior: 'smooth',
            })

            this.index += 1
        }, 5000)
    },
})
document.addEventListener('alpine:init', () => {
    window.Alpine.data('carousel', carousel)
})
